module.exports = __webpack_public_path__ + "img/dalou_8_2.cd5ec0ac.png";